/* eslint-disable */
import {otmsHttp} from '@/utils/http/index.js'

/**
 * 授信预警
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/21049
 */
export function getCredit(data) {
  return otmsHttp.post('/oms_plus/customer/order/credit/verification',data)
}